import _classCallCheck from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a, _b, _c, _d;
import { ASTWalker } from './parsers.js';
var $instances = Symbol('instances');
var $activateListener = Symbol('activateListener');
var $deactivateListener = Symbol('deactivateListener');
var $notifyInstances = Symbol('notifyInstances');
var $notify = Symbol('notify');
var $scrollCallback = Symbol('callback');
/**
 * This internal helper is intended to work as a reference-counting manager of
 * scroll event listeners. Only one scroll listener is ever registered for all
 * instances of the class, and when the last ScrollObserver "disconnects", that
 * event listener is removed. This spares us from thrashing
 * the {add,remove}EventListener API (the binding cost of these methods has been
 * known to show up in performance analyses) as well as potential memory leaks.
 */
var ScrollObserver = /*#__PURE__*/function (_ref) {
  function ScrollObserver(callback) {
    _classCallCheck(this, ScrollObserver);
    this[$scrollCallback] = callback;
  }
  _createClass(ScrollObserver, [{
    key: "observe",
    value:
    /**
     * Listen for scroll events. The configured callback (passed to the
     * constructor) will be invoked for subsequent global scroll events.
     */
    function observe() {
      if (ScrollObserver[$instances].size === 0) {
        ScrollObserver[$activateListener]();
      }
      ScrollObserver[$instances].add(this);
    }
    /**
     * Stop listening for scroll events.
     */
  }, {
    key: "disconnect",
    value: function disconnect() {
      ScrollObserver[$instances].delete(this);
      if (ScrollObserver[$instances].size === 0) {
        ScrollObserver[$deactivateListener]();
      }
    }
  }, {
    key: $notify,
    value: function value() {
      this[$scrollCallback]();
    }
  }], [{
    key: $notifyInstances,
    value: function value() {
      var _iterator = _createForOfIteratorHelper(ScrollObserver[$instances]),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var instance = _step.value;
          instance[$notify]();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: _ref,
    value: function value() {
      window.addEventListener('scroll', this[$notifyInstances], {
        passive: true
      });
    }
  }, {
    key: $deactivateListener,
    value: function value() {
      window.removeEventListener('scroll', this[$notifyInstances]);
    }
  }]);
  return ScrollObserver;
}((_a = $instances, $activateListener));
ScrollObserver[_a] = new Set();
var $computeStyleCallback = Symbol('computeStyleCallback');
var $astWalker = Symbol('astWalker');
var $dependencies = Symbol('dependencies');
var $onScroll = Symbol('onScroll');
/**
 * The StyleEffector is configured with a callback that will be invoked at the
 * optimal time that some array of CSS expression ASTs ought to be evaluated.
 *
 * For example, our CSS-like expression syntax supports usage of the env()
 * function to incorporate the current top-level scroll position into a CSS
 * expression: env(window-scroll-y).
 *
 * This "environment variable" will change dynamically as the user scrolls the
 * page. If an AST contains such a usage of env(), we would have to evaluate the
 * AST on every frame in order to be sure that the computed style stays up to
 * date.
 *
 * The StyleEffector spares us from evaluating the expressions on every frame by
 * correlating specific parts of an AST with observers of the external effects
 * that they refer to (if any). So, if the AST contains env(window-scroll-y),
 * the StyleEffector manages the lifetime of a global scroll event listener and
 * notifies the user at the optimal time to evaluate the computed style.
 */
export var StyleEffector = /*#__PURE__*/function () {
  function StyleEffector(callback) {
    var _this = this;
    _classCallCheck(this, StyleEffector);
    this[_b] = {};
    this[_c] = new ASTWalker(['function']);
    this[_d] = function () {
      _this[$computeStyleCallback]({
        relatedState: 'window-scroll'
      });
    };
    this[$computeStyleCallback] = callback;
  }
  /**
   * Sets the expressions that govern when the StyleEffector callback will be
   * invoked.
   */
  _createClass(StyleEffector, [{
    key: "observeEffectsFor",
    value: function observeEffectsFor(ast) {
      var _this2 = this;
      var newDependencies = {};
      var oldDependencies = this[$dependencies];
      this[$astWalker].walk(ast, function (functionNode) {
        var name = functionNode.name;
        var firstArgument = functionNode.arguments[0];
        var firstTerm = firstArgument.terms[0];
        if (name.value !== 'env' || firstTerm == null || firstTerm.type !== 'ident') {
          return;
        }
        switch (firstTerm.value) {
          case 'window-scroll-y':
            if (newDependencies['window-scroll'] == null) {
              var observer = 'window-scroll' in oldDependencies ? oldDependencies['window-scroll'] : new ScrollObserver(_this2[$onScroll]);
              observer.observe();
              delete oldDependencies['window-scroll'];
              newDependencies['window-scroll'] = observer;
            }
            break;
        }
      });
      for (var environmentState in oldDependencies) {
        var observer = oldDependencies[environmentState];
        observer.disconnect();
      }
      this[$dependencies] = newDependencies;
    }
    /**
     * Disposes of the StyleEffector by disconnecting all observers of external
     * effects.
     */
  }, {
    key: "dispose",
    value: function dispose() {
      for (var environmentState in this[$dependencies]) {
        var observer = this[$dependencies][environmentState];
        observer.disconnect();
      }
    }
  }]);
  return StyleEffector;
}();
_b = $dependencies, _c = $astWalker, _d = $onScroll;